module.exports = __webpack_public_path__ + "img/Middle_Exhibition_Logo.a7e746e4.png";